/**
 * Priority+ Navigation Pattern
 * Moves overflow nav items into a "More" dropdown
 */
(function() {
  const SELECTOR_NAV = '.header__inline-menu:not(.header__inline-menu-split) .list-menu--inline';
  const BREAKPOINT = 990;

  let moreItem = null;
  let moreList = null;
  let originalItems = [];
  let raf = null;

  function init() {
    const nav = document.querySelector(SELECTOR_NAV);
    if (!nav || window.innerWidth < BREAKPOINT) return;

    originalItems = Array.from(nav.children);
    if (originalItems.length < 3) return;

    moreItem = document.createElement('li');
    moreItem.className = 'nav-more';
    moreItem.innerHTML = `
      <dropdown-menu>
        <a href="#" class="header__menu-item header__menu-item--top list-menu__item focus-inset" onclick="return false">
          <span class="label">More</span>
          <svg class="icon icon-caret" viewBox="0 0 10 6" style="width:1rem;height:0.6rem;margin-left:0.4rem"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg>
        </a>
        <div class="list-menu-dropdown hidden">
          <ul class="list-menu" role="list" tabindex="-1"></ul>
        </div>
      </dropdown-menu>
    `;
    moreList = moreItem.querySelector('.list-menu');

    nav.appendChild(moreItem);
    moreItem.style.display = 'none';

    update();

    window.addEventListener('resize', () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    });
  }

  function update() {
    if (window.innerWidth < BREAKPOINT) return;

    const nav = document.querySelector(SELECTOR_NAV);
    if (!nav || !moreItem) return;

    // Restore all items to nav first
    originalItems.forEach(item => {
      if (item.parentNode !== nav) {
        nav.insertBefore(item, moreItem);
      }
      item.style.display = '';
      item.classList.remove('nav-more__restored');
    });
    moreItem.style.display = 'none';
    moreList.innerHTML = '';

    const navRect = nav.getBoundingClientRect();
    const availableWidth = navRect.width;

    let totalWidth = 0;
    const itemWidths = [];
    originalItems.forEach(item => {
      const rect = item.getBoundingClientRect();
      itemWidths.push(rect.width);
      totalWidth += rect.width;
    });

    if (totalWidth <= availableWidth) return;

    // Need to overflow — reserve space for "More" button
    moreItem.style.display = '';
    const moreWidth = moreItem.getBoundingClientRect().width + 8;

    let usedWidth = 0;
    let breakIndex = originalItems.length;

    for (let i = 0; i < originalItems.length; i++) {
      if (usedWidth + itemWidths[i] + moreWidth > availableWidth) {
        breakIndex = i;
        break;
      }
      usedWidth += itemWidths[i];
    }

    if (breakIndex >= originalItems.length) {
      moreItem.style.display = 'none';
      return;
    }

    for (let i = breakIndex; i < originalItems.length; i++) {
      const clone = originalItems[i].cloneNode(true);
      clone.querySelectorAll('.header__menu-item--top').forEach(el => {
        el.classList.remove('header__menu-item--top');
      });
      moreList.appendChild(clone);
      originalItems[i].style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    requestAnimationFrame(init);
  }
})();
